import React from 'react'
import { useRef, useState, useEffect, useCallback, useContext } from "react";
// import "../crmComponents/Addleads.css";
// import "../crmComponents/CRMList.css";
import "../crmComponents/Contacts.css";
import "../crmComponents/crmcontainer.css";
import * as Icon from "react-bootstrap-icons";
// import { Row, Col, Form, Button, Breadcrumb } from "react-bootstrap";
import LeadView from './LeadView';
import { useNavigate } from 'react-router-dom';
import Accounts from './Accounts';
import AddAccounts from './AddAccounts';
import AddLeads from './AddLeads';
import LeadDetail from './LeadDetail';
import LeadImport from './LeadImport';
import LeadMapping from './LeadMapping';

const CRMcontainer = (props) => {

    const navigate = useNavigate();


  const NextScreen = () => {
    if (props.subPageName === "leadView") {
      return <LeadView authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if (props.subPageName === "accounts") {
      return <Accounts authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if (props.subPageName === "addAccounts") {
      return <AddAccounts authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if (props.subPageName === "addLeads") {
      return <AddLeads authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if(props.subPageName === "leadDetail") {
      return <LeadDetail authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName} pageTypeHandler={props.pageTypeHandler}/>
    }
    else if(props.subPageName === "leadImport") {
      return <LeadImport authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName} pageTypeHandler={props.pageTypeHandler}/>
    }
    else if(props.subPageName === "leadMapping") {
      return <LeadMapping authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName} pageTypeHandler={props.pageTypeHandler}/>
    }
    else {
      return
    }
  }

  const viewComponent = (e) => {
    // setContacts([]);

    if (e !== "" && e.target.value === 'leadView') {
      navigate('/Lead-Management');
    } else if (e !== "" && e.target.value === 'accounts') {
      navigate('/Lead-Management/accounts');
    } 
    // else if (e !== "" && e.target.value === 'accounts') {
    //navigate to account in next phase
    //navigate('/crm/accounts');
    // }

  }

  useEffect(() => {
    props.pageTypeHandler("Lead Mangement");
  }, [])

  useEffect(()=>{
    const uData = JSON.parse(localStorage.getItem("userData"));
    if(uData?.stripeData?.stripe_day_count === 0){
      navigate(`/404`);
    }
  },[])

  return (
    <div className='pt-[3rem]'>
      <NextScreen/>
    </div>
  )
}

export default CRMcontainer
